import React, { useState, useEffect, useRef } from 'react';
import '../scss/Emsmain.scss';
import Chart from 'react-apexcharts';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/header'
import BaseURL from '../assets/contants/BaseURL';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import { Pie } from 'react-chartjs-2';

const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const fullMonthNames = [
    "January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"
];

const FlowSubGroup = () => {
    const location = useLocation();
    const { group_name } = location.state || {};
    const [selectedDate, setSelectedDate] = useState(new Date());
    const navigate = useNavigate();
    const [widgetData, setWidgetData] = useState({
        today: [0, 0, 0],
        yesterday: [0, 0, 0],
        currentMonth: [0, 0, 0],
        lastMonth: [0, 0, 0],
    });
    const [loading, setLoading] = useState(true);
    const [flowMeters, setFlowMeters] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedNewYear, setSelectedNewYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [flowData, setFlowData] = useState({
        selected_month: '',
        selected_year: '',
        group_name: '',
        group_id: null,
        group_color: '',
        total_liters: 0,
        daily_data: {}
    });
    const [flowYearData, setFlowYearData] = useState({
        selected_year: '',
        group_name: '',
        group_id: null,
        group_color: '#3743e6',
        total_liters: 0,
        monthly_data: {}
    });

    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.post(`${BaseURL}data/flow-meter-summary/`, {
                    date: today,
                    group_name: group_name,
                });
                setWidgetData({
                    today: response.data.today,
                    yesterday: response.data.yesterday,
                    currentMonth: response.data.current_month,
                    lastMonth: response.data.last_month,
                });
            } catch (error) {
                console.error('Error fetching meter summary data:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [group_name]);

    const fetchYearData = async () => {
        try {
            const response = await axios.post(`${BaseURL}data/monthly-flowdata-consumption/`, {
                group_name: group_name,
                year: selectedNewYear.toString()
            });

            const data = response.data;
            setFlowYearData(data);

        } catch (error) {
            console.error("Error fetching monthly flow data:", error);
        }
    };

    const handleNewYearChange = (e) => {
        const year = parseInt(e.target.value);
        setSelectedNewYear(year);
    };

    useEffect(() => {
        if (group_name) {
            fetchYearData();
        }
    }, [selectedYear, group_name]);

    const chartDatas = {
        categories: monthNames,
        liters: monthNames.map((month, index) => {
            const fullMonthName = fullMonthNames[index];
            const monthData = flowYearData.monthly_data[fullMonthName];
            return monthData ? monthData.liters : 0;
        })
    };

    const handleMonthChange = (e) => {
        const month = parseInt(e.target.value);
        setSelectedMonth(month);
    };

    const handleYearChange = (e) => {
        const year = parseInt(e.target.value);
        setSelectedYear(year);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(`${BaseURL}data/daily-flowdata-consumption/`, {
                    group_name: group_name,
                    month: selectedMonth,
                    year: selectedYear
                });

                setFlowData(response.data);

            } catch (error) {
                console.error("Error fetching flow consumption data:", error);
            }
        };

        if (group_name) {
            fetchData();
        }

        const intervalId = setInterval(() => {
            if (group_name) {
                fetchData();
            }
        }, 180000);

        return () => clearInterval(intervalId);
    }, [selectedMonth, selectedYear, group_name]);

    const chartData = {
        categories: Object.keys(flowData.daily_data || {}),
        liters: Object.values(flowData.daily_data || {})
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const today = new Date();
                const indiaTime = new Date(today.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
                const formattedDate = `${indiaTime.getFullYear()}-${(indiaTime.getMonth() + 1).toString().padStart(2, '0')}-${indiaTime.getDate().toString().padStart(2, '0')}`;
                const response = await axios.post(`${BaseURL}data/flow-meter-table/`, {
                    group_name: group_name,
                    date: formattedDate
                });

                const meterData = response.data;
                const updatedFlowMeters = meterData.meter_name.map((name, index) => ({
                    meter_name: name,
                    meter_id: meterData.meter_id[index],
                    group_name: meterData.group_name,
                    liters: meterData.todays_liters[index],
                    group_color: meterData.group_color
                }));

                setFlowMeters(updatedFlowMeters);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(false);
            }
        };

        if (group_name) {
            fetchData();
        }
    }, [group_name]);

    const handleMeterClick = (meterId, groupName) => {
        navigate("/EMS/FlowSub", { state: { meterId, groupName } });
        window.scrollTo(0, 0);
        console.log(meterId, groupName)
    };

    const totalLiters = flowMeters.reduce((total, meter) => total + (meter.liters || 0), 0);
    const literPercentages = flowMeters.length > 0 && totalLiters > 0
        ? flowMeters.map((meter) => {
            const percentage = (meter.liters / totalLiters) * 100;
            return percentage > 0 ? percentage : 0.001;
        })
        : new Array(flowMeters.length).fill(0);

    const getColorForMachine = (index) => {
        const colors = ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'];
        return colors[index % colors.length];
    };

    const pieChartData = {
        labels: flowMeters.map((meter) => meter.meter_name),
        datasets: [
            {
                data: literPercentages,
                backgroundColor: flowMeters.map((_, index) => getColorForMachine(index)),
            },
        ],
    };

    const indexOfLastMachine = currentPage * itemsPerPage;
    const indexOfFirstMachine = indexOfLastMachine - itemsPerPage;
    const currentFlowMeters = flowMeters.slice(indexOfFirstMachine, indexOfLastMachine);
    const totalPages = Math.ceil(flowMeters.length / itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const [chartOptions, setChartOptions] = useState({
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                tools: {
                    download: false
                },
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '50%',
                endingShape: 'rounded',
            },
        },
        colors: ['#1a27db'],
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            categories: [],
            title: {
                text: 'Time of Day',
            },
        },
        yaxis: {
            title: {
                text: 'Liters',
            },
            labels: {
                formatter: (value) => {
                    return new Intl.NumberFormat('en-US').format(value);
                },
            },
        },
        legend: {
            show: false
        },
    });
    const [chartSeries, setChartSeries] = useState([{
        name: 'Flow',
        data: []
    }]);

    useEffect(() => {
        const fetchHourlyFlowData = async () => {
            try {
                const formattedDate = selectedDate.toISOString().split('T')[0];
                const response = await axios.post(`${BaseURL}data/hourly-flowmeter-consumption/`, {
                    group_name: group_name,
                    date: formattedDate
                });

                const data = response.data;

                const categories = Object.keys(data.hourly_data);
                const litersData = categories.map(time => data.hourly_data[time]);

                setChartOptions(prev => ({
                    ...prev,
                    xaxis: {
                        ...prev.xaxis,
                        categories: categories
                    }
                }));

                setChartSeries([{
                    name: 'Flow (Liters)',
                    data: litersData
                }]);

            } catch (error) {
                console.error("Error fetching hourly flow data:", error);
            }
        };

        if (group_name) {
            fetchHourlyFlowData();
        }
    }, [selectedDate, group_name]);

    return (
        <div className="dashboard-container">
            <Header title="BRADKEN WATER FLOW MANAGEMENT DASHBOARD" />

            <div className="card-container" style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                marginTop: '50px',
                maxWidth: '1000px',
                marginLeft: 'auto',
                marginRight: 'auto'
            }}>
                <h3 className="dashboard-subtitle"><span onClick={() => navigate('/EMS/flowportal')} style={{ color: '#007bff', cursor: 'pointer' }} title="Navigate to Group Portal">MAIN</span> {' / '} {group_name}</h3>
                {/* <div className="widgets-container" style={{ display: 'grid',  gap: '20px', marginBottom: '20px' }}> */}
                <div className="widgets-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '20px' }}>

                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Today's</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Flow</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `${widgetData.today[0].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L`
                                    )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #4caf50, #2b9e36)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Yesterday</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Flow</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `${widgetData.yesterday[0].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L`
                                    )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #2196f3, #0b7dda)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Current Month</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Flow</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `${widgetData.currentMonth[0].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L`
                                    )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #f44336, #d32f2f)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Last Month</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Flow</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `${widgetData.lastMonth[0].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L`
                                    )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="card-container"
                    style={{
                        border: "1px solid #ccc",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                        marginTop: "30px",
                        maxWidth: "1000px",
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginBottom: '20px',
                        padding: "10px",
                        borderRadius: "10px",
                    }}
                >
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        marginBottom: '20px',
                    }}>
                        <div style={{
                            width: '300px',
                            height: '300px',
                            marginBottom: '20px',
                        }}>
                            <Pie
                                data={pieChartData}
                                options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            display: false,
                                            position: 'bottom',
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: function (tooltipItem) {
                                                    const value = tooltipItem.raw.toFixed(2);
                                                    return `${tooltipItem.label}: ${value}%`;
                                                },
                                            },
                                        },
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <table
                        className="sub-meters-table"
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            textAlign: "center",
                        }}
                    >
                        <thead>
                            <tr>
                                <th
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        backgroundColor: "#f4f4f4",
                                    }}
                                >
                                    S.NO
                                </th>
                                <th
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        backgroundColor: "#f4f4f4",
                                    }}
                                >
                                    Flow Meter Name
                                </th>
                                <th
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        backgroundColor: "#f4f4f4",
                                    }}
                                >
                                    Flow Meter ID
                                </th>
                                <th
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        backgroundColor: "#f4f4f4",
                                    }}
                                >
                                    Group
                                </th>
                                <th
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        backgroundColor: "#f4f4f4",
                                    }}
                                >
                                    Today's Flow
                                </th>
                                <th style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    backgroundColor: "#f4f4f4",
                                }}
                                >
                                    Unit %
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentFlowMeters.map((meter, index) => (
                                <tr
                                    key={meter.meter_id}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleMeterClick(meter.meter_id, meter.group_name)}
                                >
                                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                        {index + 1 + (currentPage - 1) * itemsPerPage}
                                    </td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                        {meter.meter_name}
                                    </td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                        {meter.meter_id}
                                    </td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                        {meter.group_name}
                                    </td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "right" }}>
                                        {meter.liters.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                        <div
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                                backgroundColor: getColorForMachine(index),
                                                borderRadius: '50%',
                                                display: 'inline-block',
                                                marginRight: '8px',
                                            }}
                                        ></div>
                                        <span>{literPercentages[index + indexOfFirstMachine].toFixed(2)}%</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="4" style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", backgroundColor: "#f9f9f9" }}>
                                    Total
                                </td>
                                <td style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", backgroundColor: "#f9f9f9", textAlign: "right" }}>
                                    {totalLiters.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </td>
                                <td style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", backgroundColor: "#f9f9f9", textAlign: "right" }}>

                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{
                                marginRight: '10px',
                                padding: '5px 10px',
                                background: currentPage === 1 ? '#007acc' : '#007acc',
                                border: 'none',
                                borderRadius: '25px',
                                color: 'white',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                                boxShadow: currentPage === 1 ? 'none' : '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                fontSize: '12px',
                            }}
                        >
                            Previous
                        </button>

                        {Array.from({ length: totalPages }, (_, i) => (
                            <button
                                key={i}
                                onClick={() => paginate(i + 1)}
                                style={{
                                    margin: '0 5px',
                                    padding: '5px 10px',
                                    background: currentPage === i + 1 ? '#007acc' : 'linear-gradient(to right, #f7f7f7, #e0e0e0)',
                                    color: currentPage === i + 1 ? '#ffffff' : '#333333',
                                    border: '1px solid #ddd',
                                    borderRadius: '25px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    transition: 'background-color 0.3s ease',
                                }}
                            >
                                {i + 1}
                            </button>
                        ))}

                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={{
                                marginLeft: '10px',
                                padding: '5px 10px',
                                background: currentPage === totalPages ? '#007acc' : '#007acc',
                                border: 'none',
                                borderRadius: '25px',
                                color: 'white',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                                boxShadow: currentPage === totalPages ? 'none' : '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                fontSize: '12px',
                            }}
                        >
                            Next
                        </button>
                    </div>
                </div>
                <div
                    className="extra-details-row"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '20px',
                    }}
                >
                </div>
                <div className="charts-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f9f0f3',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Hourly Data</h4>
                        <div style={{ marginBottom: "20px" }}>
                            <label
                                htmlFor="date-picker"
                                style={{
                                    alignItems: "center",
                                    marginBottom: "20px",
                                }}
                            >
                                Date:
                            </label>
                            <DatePicker
                                id="date-picker"
                                selected={selectedDate}
                                onChange={(date) => setSelectedDate(date)}
                                dateFormat="yyyy/MM/dd"
                                customInput={
                                    <input
                                        style={{
                                            fontSize: "12px",
                                            width: '55%',
                                        }}
                                    />
                                }
                            />
                        </div>
                        <Chart
                                    options={chartOptions}
                                    series={chartSeries}
                                    type="bar"
                                    height={350}
                                    width={950}
                                />
                    </div>
                </div>
                <div
                    className="charts-container"
                    style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}
                >
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#fbe9f6',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Day's Consumption</h4>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Month:
                            </label>
                            <select
                                value={selectedMonth}
                                onChange={handleMonthChange}
                                style={{
                                    padding: "5px",
                                    marginRight: "20px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {monthNames.map((month, index) => (
                                    <option key={index + 1} value={index + 1}>
                                        {month}
                                    </option>
                                ))}
                            </select>

                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Year:
                            </label>
                            <select
                                value={selectedYear}
                                onChange={handleYearChange}
                                style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    backgroundColor: '#fbe9f6',
                                    toolbar: {
                                        tools: {
                                            zoom: false,
                                            zoomin: false,
                                            zoomout: false,
                                            pan: false,
                                            reset: false,
                                            download: false,
                                        },
                                    },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '50%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: [flowData.group_color || '#3743e6'],
                                dataLabels: {
                                    enabled: false,
                                },
                                xaxis: {
                                    categories: chartData.categories,
                                    title: {
                                        text: 'Dates',
                                    },
                                },
                                yaxis: {
                                    title: {
                                        text: 'Liters',
                                    },
                                    labels: {
                                        formatter: (value) => {
                                            return new Intl.NumberFormat('en-US').format(value);
                                        },
                                    },
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value) {
                                            return `${value.toLocaleString()} liters`;
                                        },
                                    },
                                },
                            }}
                            series={[{
                                name: 'Water Flow',
                                data: chartData.liters
                            }]}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
                <div className="charts-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f0fbff',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Monthly Consumption</h4>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Year:
                            </label>
                            <select
                                value={selectedNewYear}
                                onChange={handleNewYearChange}
                                style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    backgroundColor: '#f0fbff',
                                    toolbar: {
                                        tools: {
                                            zoom: false,
                                            zoomin: false,
                                            zoomout: false,
                                            pan: false,
                                            reset: false,
                                            download: false,
                                        },
                                    },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '50%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: ['#3743e6'],
                                dataLabels: {
                                    enabled: false,
                                },
                                xaxis: {
                                    categories: chartDatas.categories,
                                    title: {
                                        text: 'Months',
                                    },
                                },
                                yaxis: {
                                    title: {
                                        text: 'Liters',
                                    },
                                    labels: {
                                        formatter: (value) => {
                                            return new Intl.NumberFormat('en-US').format(value);
                                        },
                                    },
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value) {
                                            return `${value.toLocaleString()} liters`;
                                        },
                                    },
                                },
                            }}
                            series={[{
                                name: 'Water Flow',
                                data: chartDatas.liters
                            }]}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FlowSubGroup;
